export default __webpack_public_path__ + "static/media/music.inline.749e8bbb.svg";